import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-empty-state',
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="es">
      <div class="es-icon"><mat-icon>{{ icon }}</mat-icon></div>
      <div class="es-title">{{ heading }}</div>
      <div class="es-msg" *ngIf="message">{{ message }}</div>
      <div class="es-cta"><ng-content></ng-content></div>
    </div>
  `,
  styles: [`
    .es {
      display: flex; flex-direction: column; align-items: center; justify-content: center;
      text-align: center; padding: 64px 24px; gap: 8px;
    }
    .es-icon {
      width: 84px; height: 84px; border-radius: 24px;
      display: grid; place-items: center; margin-bottom: 8px;
      background: rgba(51,65,85, .07);
      mat-icon { font-size: 40px; width: 40px; height: 40px; color: #334155; opacity: .65; }
    }
    .es-title { font-size: 17px; font-weight: 700; color: #2a2024; }
    .es-msg { font-size: 13px; color: #9a8f93; max-width: 360px; line-height: 1.5; }
    .es-cta { margin-top: 10px; &:empty { display: none; } }
  `],
})
export class EmptyStateComponent {
  @Input() icon = 'inbox';
  @Input() heading = 'Nothing here yet';
  @Input() message = '';
}
